import React, { Suspense, useEffect } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './new-subscribe.styles.scss';
import { getPageDataByApiUrl } from '../../../js/api/get-pages.data';

function NewSubscribeLandingPageDesign() {
  const [mainContent, setMainContent] = React.useState({});

  const HeroComponent = React.lazy(() => import('./new-subscribe-hero'));
  const ContentComponent = React.lazy(() =>
    import('./new-subscribe-landing-page-design-content')
  );

  useEffect(async () => {
    const response = await getPageDataByApiUrl(
      '/restapi/customsubscribecontent/subscribe'
    );
    if (response) {
      setMainContent(response?.MainContent);
    }
  }, []);

  if (Object.keys(mainContent).length > 0) {
    return (
      <div>
        <div>
          <div className="subscribe-container">
            <Suspense fallback={<Loader />}>
              <HeroComponent MainContent={mainContent} />
            </Suspense>
          </div>
          <div className="indiv-container indiviual">
            <div className="trinity-container module-spacer">
              <Suspense fallback={<Loader />}>
                <ContentComponent MainContent={mainContent} />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <Loader />;
}

export default NewSubscribeLandingPageDesign;
